import * as Types from "../../../../../../types/__generated__/graphql";

import {gql} from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type SendPasswordlessLoginMutationVariables = Types.Exact<{
  input: Types.SendPasswordlessLoginInput;
}>;

export type SendPasswordlessLoginMutation = {
  __typename?: "Mutation";
  sendPasswordlessLogin?: {
    __typename?: "SendPasswordlessLoginResponse";
    message?: string | null;
    success: boolean;
  } | null;
};

export const SendPasswordlessLoginDocument = gql`
  mutation SendPasswordlessLogin($input: SendPasswordlessLoginInput!) {
    sendPasswordlessLogin(input: $input) {
      message
      success
    }
  }
`;
export type SendPasswordlessLoginMutationFn = Apollo.MutationFunction<
  SendPasswordlessLoginMutation,
  SendPasswordlessLoginMutationVariables
>;

/**
 * __useSendPasswordlessLoginMutation__
 *
 * To run a mutation, you first call `useSendPasswordlessLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPasswordlessLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPasswordlessLoginMutation, { data, loading, error }] = useSendPasswordlessLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendPasswordlessLoginMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendPasswordlessLoginMutation,
    SendPasswordlessLoginMutationVariables
  >,
) {
  const options = {...defaultOptions, ...baseOptions};
  return Apollo.useMutation<SendPasswordlessLoginMutation, SendPasswordlessLoginMutationVariables>(
    SendPasswordlessLoginDocument,
    options,
  );
}
export type SendPasswordlessLoginMutationHookResult = ReturnType<
  typeof useSendPasswordlessLoginMutation
>;
export type SendPasswordlessLoginMutationResult =
  Apollo.MutationResult<SendPasswordlessLoginMutation>;
export type SendPasswordlessLoginMutationOptions = Apollo.BaseMutationOptions<
  SendPasswordlessLoginMutation,
  SendPasswordlessLoginMutationVariables
>;
